import api from '@/apis/di/contractAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('contract', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_contract',
    field: {
      key: 'contract_id',
      code: 'contract_no',
      name: 'contract_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
